export const ThankYouStep = () => {
  return (
    <div className="text-center py-8">
      <h3 className="text-xl font-medium text-primary-dark mb-4">
        Thank you for submitting your claim
      </h3>
      <p className="text-gray-600">
        Your agent will process your claim and contact you shortly.
      </p>
    </div>
  );
};